import { Checkbox, IconButton, Stack } from "@mui/material";
import axios from "axios";
import { useState, useEffect, Fragment } from "react";
import { Icon } from "@iconify/react";
import iconArrowDown from "@iconify/icons-eva/arrow-ios-forward-outline";
import { asyncRequest } from "src/services/network";

const AccessControls = ({ defaultCtrls, onChange }) => {
  // console.log('defaultCtrls', defaultCtrls)
  const [accessctrls, setAccessCtrls] = useState(null);
  const [ctrlIds, setCtrlIds] = useState(defaultCtrls || []);
  const [foldMap, setFoldMap] = useState({});
  const [checkedMap, setCheckedMap] = useState({});
  const [menus, setMenus] = useState([]);

  // console.log(checkedMap, defaultCtrls)
  useEffect(() => {
    getMenus();
  }, []);

  useEffect(() => {
    if (!accessctrls) return;
    traverseCtrls();
  }, [accessctrls, ctrlIds]);

  async function getMenus() {
    const { data } = await asyncRequest({
      method: "get",
      path: "/system/menu/all",
    });

    if (!data.length) return;
    const menus = [...data];

    const levels = [];

    for (let i = 0; i < menus.length; i++) {
      const level = (menus[i].level || 1) - 1;
      if (!levels[level]) {
        levels[level] = [];
      }

      levels[level].push(menus[i]);
    }

    for (let i = levels.length - 1; i > 0; i--) {
      for (let j = 0; j < levels[i].length; j++) {
        const parentGroup = levels[i - 1];
        const parent = parentGroup.find((p) => p.id == levels[i][j].pid);

        if (!parent.children) {
          parent.children = [];
        }

        parent.children.push(levels[i][j]);
      }
    }

    setMenus(menus);
    setAccessCtrls(levels[0]);
  }

  function handleFolding(id) {
    setFoldMap({
      ...foldMap,
      [id]: !foldMap[id],
    });
  }

  function handleRowChecked(checked, row) {
    let ctrls = [...ctrlIds];

    // console.log(row);
    if (checked) {
      // 父级也要选上
      ctrls.push(row.id);
      let pid = row.pid;
      while (pid) {
        ctrls.push(pid);
        const parent = menus.find(menu => menu.id == pid);
        if (!parent) break;
        pid = parent.pid;
      }
    } else {
      ctrls = ctrls.filter((c) => c !== row.id);

      // 如果父级没有子选项，也删除了
      let map = {...checkedMap};
      let pid = row.pid;
      while (pid) {
        const parent = menus.find(menu => menu.id == pid);
        if (!parent) break;

        let count = 0;
        for (let k in map) {
          if (row.id == k) continue;
          if (menus.find(menu => menu.pid == pid && k == menu.id)) {
            count++;
          }
        }
        // console.log(count);
        if (count == 0) {
          ctrls = ctrls.filter((c) => c !== pid);
          delete map[pid];
        }

        pid = parent.pid;
      }
    }

    if (row.children) {
      let toCheck = true;
      // 考虑下级问题
      if (checkedMap[row.id] > 0) {
        toCheck = false;
      }

      toggleChildren(row.children, ctrls, toCheck);
    }

    ctrls = [...new Set(ctrls)];
    // console.log(ctrls);

    setCtrlIds(ctrls);

    setTimeout(() => {
      // console.log(ctrls);
      onChange(ctrls);
    }, 0);
  }
  

  function traverseCtrls() {
    const map = {};
    for (let i = 0; i < ctrlIds.length; i++) {
      map[ctrlIds[i]] = true;
    }

    setCheckedMap(map)
  }

  function toggleChildren(menus, ctrls, check = true) {
    if (!menus) return;
    for (let i = 0; i < menus.length; i++) {
      const { id, children } = menus[i];
      const idx = ctrls.indexOf(id);

      if (check) {
        if (idx == -1) {
          ctrls.push(id);
        }
      } else {
        if (idx > -1) {
          ctrls.splice(idx, 1);
        }
      }

      toggleChildren(children, ctrls, check);
    }
  }

  function renderRows(rows, visible = true) {
    if (!rows) return;

    return rows.map((row, i) => {
      const { id, name, pid, children, level } = row;

      if (visible) {
        visible = foldMap[pid];
      }

      let display = "none";
      if (level == 1 || visible) {
        display = "";
      }

      return (
        <Stack direction="column" key={id}>
          <Stack direction="row" alignItems="center" style={{ display }}>
            <Stack direction="row" alignItems="center" className={`rc level${level}`} style={{ paddingLeft: 16 * (level - 1) }}>
              <IconButton
                style={{
                  transform: `rotate(${foldMap[id] ? 90 : 0}deg)`,
                }}
                onClick={() => handleFolding(row.id)}
              >
                <Icon icon={iconArrowDown} style={{ visibility: !!children ? "visible" : "hidden" }} />
              </IconButton>
              <Checkbox checked={checkedMap[id] || false} onChange={(e) => handleRowChecked(e.target.checked, row)} />
            </Stack>
            <span>{name}</span>
          </Stack>
          {renderRows(children, visible)}
        </Stack>
      );
    });
  }

  // , overflow: "auto"
  return <Stack sx={{ minWidth: 500, height: 600 }}>{renderRows(accessctrls)}</Stack>;
};

export default AccessControls;
